/**
 * @desc 课程模块
 */
const courseList = r => require.ensure([],() => r(require('../views/course/CourseList.vue')) ,'courseList');
const evaluation = r => require.ensure([],() => r(require('../views/course/Evaluation.vue')) ,'evaluation');
const RecommendedCourse = r => require.ensure([],() => r(require('../views/course/RecommendedCourse.vue')) ,'RecommendedCourse');
const scheduleEvalution = r => require.ensure([],() => r(require('../views/course/Assess.vue')),'scheduleEvaluation');

const questionnaireSurvey = r => require.ensure([],() => r(require('../views/course/QuestionnaireSurvey.vue')),'questionnaireSurvey');

export default [
  //课程列表
  {
    name: 'courseList',
    path: '/courseList',
    component: courseList,
    meta: {title: '课程列表'},
  },
  //评价列表
  {
    name: 'evaluation',
    path: '/evaluation',
    component: evaluation,
    meta: {title: '评价列表'},
  },
  // 课节评价
  {
    name: 'scheduleEvaluation',
    path: '/scheduleEvaluation',
    component: scheduleEvalution,
    meta: {title: '课节评价'},
  },
  {
    name: 'RecommendedCourse',
    path: '/RecommendedCourse',
    component: RecommendedCourse,
    meta: {title: '推荐列表'},
  },
  {
    name: 'questionnaireSurvey',
    path: '/questionnaireSurvey',
    component: questionnaireSurvey,
    meta: {title: '问卷调查'},
  }
  
]